<template>
  <div class="modal fade" ref="cropImageModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
       data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">Editar imagem</h5>

          <button type="button" class="close" @click="toggleModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

        </div>
        <div class="modal-body modal-crop-image">
          <p class="info-block col-md-12 text-center">
            <i
              class="fa fa-info-circle"
              data-placement="right"
              data-toggle="popover"
              data-trigger="hover"
              data-content="Mantenha a tecla shift do teclado pressionada para aumentar a área de recorte na mesma proporção">
            </i>
            Tipos de imagem permitidos: PNG, JPEG, WEBP e GIF
          </p>
          <simple-drag-and-drop
            v-if="!image"
            :should-resize="true"
            label="Selecione ou arraste uma imagem"
            accept="image/png,image/jpg,image/jpeg,image/gif,image/webp">
          </simple-drag-and-drop>

          <div v-if="image" class="cropper-area">

            <vue-cropper
              view-mode="1"
              ref="cropper"
              :src="image"
              :containerStyle="{'max-height': '61vh'}"
              alt="Source Image"
              preview=".preview"
            >
            </vue-cropper>
          </div>

        </div>
        <div class="modal-footer">
          <template v-if="image">

            <button type="button" class="btn btn-outline-secondary waves-effect waves-light" @click.prevent="zoom(0.2)">
              <i class="fa fa-search-plus"></i>
              Aumentar
            </button>
            <button type="button" class="btn btn-outline-secondary waves-effect waves-light"
                    @click.prevent="zoom(-0.2)">
              <i class="fa fa-search-minus"></i>
              Diminuir
            </button>
            <button type="button" class="btn btn-outline-secondary waves-effect waves-light"
                    @click.prevent="proportion()">
              <i class="far fa-images"></i>
              Proporção
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary btn-reset waves-effect waves-light"
              @click.prevent="reset">
              Limpar
            </button>
          </template>
          <button
            type="button"
            class="btn btn-outline-secondary waves-effect waves-light"
            @click="toggleModal">
            Fechar
          </button>
          <button
            type="button"
            class="btn btn-secondary waves-effect waves-light text-white"
            :disabled="!image"
            @click="cropImage">
            Recortar e salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SimpleDragAndDrop from '@/components/SimpleDragAndDrop.vue';
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';

  export default {
    name: 'crop-image-modal',

    components: {
      SimpleDragAndDrop,
      VueCropper,
    },

    mounted() {
      this.$root.$on('show-crop-modal', (payload) => this.toggleModal(payload));
      this.$root.$on('sending-back-base64', (payload) => this.retrieveBase64(payload));
    },

    watch: {
      image() {
        this.$nextTick().then(function () {
          let div = $('[data-toggle="popover"]')
          if (div)
            div.popover();
        });
      },
    },

    data() {
      return {
        image: undefined,
        index: undefined,
        cropImg: undefined,
        boxWidth: 0,
        boxHeight: 0,
      };
    },

    methods: {
      retrieveBase64(payload) {
        if (payload.fileType !== 'image/gif')
          return this.image = payload.base64;

        this.$root.$emit('handle-cropped-image', {
          index: this.index,
          base64: payload.base64,
        });

        this.toggleModal();
      },

      toggleModal(payload = {}) {
        this.boxWidth = payload.width;
        this.boxHeight = payload.height;
        this.index = payload.index;
        this.image = undefined;
        this.cropImg = undefined;

        $(this.$refs.cropImageModal).modal('toggle');
      },

      cropImage() {
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.$root.$emit('handle-cropped-image', {
          index: this.index,
          base64: this.cropImg,
        });

        this.toggleModal();
      },

      reset() {
        this.$refs.cropper.reset();
      },

      showFileChooser() {
        this.$refs.input.click();
      },
      zoom(percent) {
        this.$refs.cropper.relativeZoom(percent);
      },
      proportion() {
        let cropperData = this.$refs.cropper.getData();
        cropperData.width = this.boxWidth;
        cropperData.height = this.boxHeight;

        this.$refs.cropper.setCropBoxData(cropperData);
      },
    },
  };
</script>

<style scoped>
  .fa-info-circle {
    color: #ED1763;
    margin-right: 1em;
    cursor: pointer;
  }

  .btn-reset {
    margin-right: 1em;
  }
</style>

<style>
  .cropper-area {
    max-width: 100%;
    max-height: 100%;
  }

  .modal {
    z-index: 10000 !important;
  }

  @media screen and (max-width: 500px) {
    .modal-backdrop {
      position: absolute;
    }
  }

  .info-block {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CropImageModal.vue